import { render, staticRenderFns } from "./OnlinePresence.vue?vue&type=template&id=0991811e&scoped=true&"
import script from "./OnlinePresence.vue?vue&type=script&lang=js&"
export * from "./OnlinePresence.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePresence.vue?vue&type=style&index=0&id=0991811e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0991811e",
  null
  
)

export default component.exports